import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './join';
import track from 'utils/track';

export default function (props) {
  const {
    phases: {
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'C-HBC',
      sku: 'C-HBC',
      name: 'Healthy Brain',
      variant: salesSchedule.phase != 'during' ? 'hbc' : 'hbc-special',
      value: salesSchedule.phase != 'during' ? 497 : 297,
      currency: 'usd'
    });
  }, [salesSchedule.phase]);

  return <SalesIndex ctaOverride={salesSchedule.phase != 'during' ? 'sales497' : 'sales297'} version="salesSpecial" />;
}
